var map = {
	"./CatalogCarousel/CatalogCarousel.vue": [
		1175,
		167
	],
	"./CatalogCarousel/CatalogItem.vue": [
		1168,
		246
	],
	"./MarketingCards.vue": [
		319
	],
	"./ProductCarousel/CarouselProductItem.vue": [
		1169,
		247
	],
	"./ProductCarousel/ProductCarousel.vue": [
		1176,
		6,
		112
	],
	"./ReorderHighlight/ReorderHighlight.vue": [
		1177,
		171
	],
	"./VoucherCarousel/VoucherCardItem.vue": [
		401
	],
	"./VoucherCarousel/VoucherCarousel.vue": [
		397
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1145;
module.exports = webpackAsyncContext;